const TECHNICAL_ERROR = /(error|exception|traceback|429|401|403|503|api[_ ]?key|quota|credit|unavailable|rate.?limit)/i;

export function publicPipelineError(message) {
  if (!message || TECHNICAL_ERROR.test(message)) {
    return "El servicio de lectura no pudo completar esta tarea. Intenta de nuevo en unos minutos.";
  }
  return message;
}

export const JOB_LABELS = {
  process_document: "Leer pagina",
  generate_thumbnail: "Crear vista previa",
  structure_pack: "Organizar apuntes",
  index_pack: "Preparar material",
  generate_questions: "Crear ejercicios",
  delete_storage_objects: "Descartar pagina",
};

export function jobLabel(jobType) {
  return JOB_LABELS[jobType] || "Procesar material";
}
